import { useEffect, useState } from "react";
import "./App.css";
import HyperbolaBackground from "./HyperbolaBackground";

function App() {
  const [showGeoGebra, setShowGeoGebra] = useState(false);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.3 }
    );

    document.querySelectorAll(".block").forEach((el) => {
      observer.observe(el);
    });

    const timer = setTimeout(() => {
      setShowGeoGebra(true);
    }, 1200);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <HyperbolaBackground />

      <div className="App">
        {/* NAVBAR */}
        <nav className="navbar animate-nav">
          <div className="logo">
            <img src="/logo.png" alt="Pasta Bridge Logo" />
          </div>

          <div className="menu">
            <span onClick={() => scrollTo("obiettivo")}>Obiettivo</span>
            <span onClick={() => scrollTo("materiali")}>Materiali</span>
            <span onClick={() => scrollTo("progettazione")}>Progettazione</span>
            <span onClick={() => scrollTo("costruzione")}>Costruzione</span>
            <span onClick={() => scrollTo("risultati")}>Conclusioni</span>
          </div>
        </nav>

        {/* HERO */}
        <header className="hero">
          <svg className="hyper-svg" viewBox="0 0 800 300">
            <path className="hyper-line line1" d="M10,150 C150,20 300,280 450,150 600,20 750,280 790,150" />
            <path className="hyper-line line2" d="M10,170 C180,40 320,260 460,170 620,40 760,260 790,170" />
            <path className="hyper-line line3" d="M10,130 C170,10 310,290 460,130 610,10 760,290 790,130" />
          </svg>

          <h1
            className="click-title animate-title hyper-title"
            onClick={() => scrollTo("obiettivo")}
          >
            DALLA CONICA AL PONTE
          </h1>

          <p className="animate-sub">
            Relazione di progetto sulla progettazione e realizzazione
            di un ponte utilizzando la pasta
          </p>

          <p className="authors">
            Realizzato da: Ryle Nathan Cantillano | Davide Manente | Francesco Medici
          </p>
        </header>

        {/* CONTENT */}
        <main className="content">
          <section id="obiettivo" className="block">
            <h2>OBIETTIVO</h2>
            <p>
              L'obiettivo del progetto era progettare e costruire un ponte di
              pasta utilizzando la conica assegnata, nello specifico l'iperbole,
              applicando lo studio delle coniche alla realizzazione di una
              struttura reale.
            </p>
          </section>

          <section id="materiali" className="block">
            <h2>MATERIALI</h2>
            <p>
              Per la realizzazione del ponte sono stati utilizzati diversi tipi
              di pasta, tra cui tortiglioni, penne, spaghetti, linguine e
              bucatini. Per incollare i pezzi abbiamo usato colla Attak e molta
              colla a caldo, in modo da rendere il ponte più stabile e resistente.
            </p>
          </section>

          <section id="progettazione" className="block">
            <h2>PROGETTAZIONE</h2>
            <p>
              La progettazione del ponte è stata realizzata utilizzando GeoGebra
              per disegnare la conica assegnata, cioè l’iperbole, e per capire come
              inserirla nella struttura del ponte. La curva iperbolica è stata
              utilizzata come supporto principale della parte superiore, cioè
              la strada.
              <br /><br />
              Per aumentare la stabilità sono stati inseriti supporti
              triangolari, perché il triangolo è una forma rigida che aiuta a
              evitare deformazioni. Durante la costruzione il progetto ha subito
              alcune piccole modifiche per fornire ancora più stabilità.
            </p>

            {/* GEOGEBRA */}
            <div className="geogebra-container">
              {showGeoGebra && (
                <iframe
                  src="https://www.geogebra.org/classic/e58swysj?embed"
                  title="Ponte"
                  width="100%"
                  height="520"
                  frameBorder="0"
                  loading="lazy"
                  style={{
                    border: "1px solid #e4e4e4",
                    borderRadius: "8px",
                  }}
                />
              )}
            </div>

            {/* TINKERCAD IFRAME – SOLO AGGIUNTO */}
            <div className="model-container tinkercad-container">
              <iframe
                src="https://www.tinkercad.com/embed/6Qll3JDxmqD?editbtn=1&simlab=1"
                title="Tinkercad Ponte"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </section>

          <section id="costruzione" className="block">
            <h2>COSTRUZIONE</h2>
            <p>
              La costruzione è partita dalla base, incollata su un pezzo di
              cartone per rendere la struttura più stabile. Successivamente sono
              stati realizzati i pilastri, che permettono di dare altezza al
              ponte.
              <br /><br />
              Dopo i pilastri è stata costruita la curva iperbolica, sopra la
              quale sono state aggiunte delle travi per creare un appoggio
              solido. In seguito è stato sistemato il supporto della strada,
              inizialmente leggermente sfalsato, e infine è stata realizzata la
              strada vera e propria con alcune decorazioni.
            </p>
          </section>

          <section id="risultati" className="block">
            <h2>CONCLUSIONI</h2>
            <p>
              Il lavoro è stato completato con successo. Non è stato effettuato
              un test di carico per evitare il rischio di danneggiare la
              struttura. L’esperienza è stata divertente ma anche impegnativa a
              causa della fragilità della pasta.
              <br /><br />
              Questo progetto ha permesso di applicare la matematica in modo
              pratico e creativo, rendendo il lavoro più interessante rispetto
              ai classici esercizi di calcolo.
            </p>

            <div className="image-frame curtain-container"
              onClick={(e) => e.currentTarget.classList.add("open")}>
              <div className="curtain left" />
              <div className="curtain right" />

               <img src="/PonteFINAL.png" alt="Ponte di pasta" />

                <div className="curtain-text">CLICCA PER APRIRE IL SIPARIO</div>
            </div>

          </section>
        </main>
      </div>
    </>
  );
}

export default App;
